import { GETConfig, POSTConfig } from "@/types/common.types";
import {
	AddInsurerParams,
	Insurer,
	UpdateInsurerParams,
} from "@/types/insurer.types";
import axios from "axios";

const server_url = process.env.REACT_APP_SERVER_DOMAIN;

export const addInsurer = async (
	accessToken: string,
	params: AddInsurerParams
) => {
	const response = await axios.post(
		`${server_url}case/addinsurers`,
		params,
		POSTConfig(accessToken)
	);

	return response.data;
};

export const updateInsurer = async (
	accessToken: string,
	params: UpdateInsurerParams
) => {
	const response = await axios.post(
		`${server_url}case/updateinsurer`,
		params,
		POSTConfig(accessToken)
	);
	return response.data;
};

export const getInsurers = async (accessToken: string): Promise<Insurer[]> => {
	const res = await axios.get(
		`${server_url}case/getinsurers`,
		GETConfig(accessToken)
	);
	return res.data;
};

export const getSingleInsurer = async (
	insurerid: number,
	accessToken: string
): Promise<Insurer> => {
	const res = await axios.get(
		`${server_url}case/getsingleinsurer/${insurerid}`,
		GETConfig(accessToken)
	);
	return res.data[0];
};
